export default __webpack_public_path__ + "static/media/case3 (1).8ccdf960.jpg";